import React from "react";
import SEOHead from "../section/SeoHead";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Privacy Policy - Citizen Hub",
    description: "Privacy Policy for Citizen Hub Immigration Services.",
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <SEOHead
        title={`${t("legal.privacy.title")} - Citizen Hub`}
        description={t("legal.privacy.intro_text")}
        canonicalUrl="https://citiznhub.com/privacy-policy"
        structuredData={structuredData}
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-xl p-8 md:p-12"
        >
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 border-b pb-4">
            {t("legal.privacy.title")}
          </h1>

          <div className="prose prose-blue max-w-none text-gray-700 space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t("legal.privacy.intro_title")}</h2>
              <p className="lead text-lg text-gray-600">
                {t("legal.privacy.intro_text")}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t("legal.privacy.collection_title")}</h2>
              <p>
                {t("legal.privacy.intro_text")}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t("legal.privacy.usage_title")}</h2>
              <p>{t("legal.privacy.intro_text")}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t("legal.privacy.security_title")}</h2>
              <p>{t("legal.privacy.data_security_title")}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t("legal.privacy.cookies_title")}</h2>
              <p>{t("legal.privacy.intro_text")}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t("legal.privacy.links_title")}</h2>
              <p>{t("legal.privacy.third_party_title")}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t("legal.privacy.terms_title")}</h2>
              <p>{t("legal.privacy.terms_text")}</p>
            </section>

            <section className="bg-blue-50 p-6 rounded-xl border border-blue-100">
              <h2 className="text-xl font-bold text-blue-900 mb-2">{t("legal.privacy.contact_title")}</h2>
              <p className="text-blue-800">info@citizenhub.com</p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
